import { type FC, type ReactNode, useState } from "react";
import { Icon } from "@root/shared/components/Icon";
import { colors, fontSize } from "@root/shared/styles/sprinkles.css";
import { ToolTip } from "@root/shared/components/ToolTip";
import { type ArrowPosition } from "@root/shared/types/type";
import * as styles from "./styles.css";

export type TooltipWithIconProps = {
  children: ReactNode;
  arrowPosition: ArrowPosition;
  outerClassName?: string;
  tooltipZIndex?: string;
  onShowTooltip?: () => void;
  onHideTooltip?: () => void;
};

export const TooltipWithIcon: FC<TooltipWithIconProps> = ({
  children,
  arrowPosition,
  outerClassName,
  tooltipZIndex,
  onShowTooltip,
  onHideTooltip,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const handleShowTooltip = () => {
    onShowTooltip?.();
    setIsHovered(true);
  };
  const handleHideTooltip = () => {
    onHideTooltip?.();
    setIsHovered(false);
  };

  return (
    <div
      className={`${styles.outer} ${outerClassName ?? ""}`}
      onMouseEnter={handleShowTooltip}
      onMouseLeave={handleHideTooltip}
      role="tooltip"
      aria-label="ヘルプ情報"
    >
      <Icon name="tooltip" color={colors.TextLink} fontSize={fontSize["fs-16"]} />
      {isHovered && (
        <ToolTip
          arrowPosition={arrowPosition}
          isHovered
          className={styles.toolTip({ arrowPosition })}
          {...(tooltipZIndex && { zIndex: tooltipZIndex })}
        >
          {children}
        </ToolTip>
      )}
    </div>
  );
};
